export default __webpack_public_path__ + "static/media/Savior's Sky Piercer.4f26969c.jpg";